import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { HelperService } from 'app/shared/services/helper.service';

@Component({
  selector: 'app-news-view-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './news-view-header.component.html',
  styleUrl: './news-view-header.component.scss'
})
export class NewsViewHeaderComponent {
  @Input() title!: string;
  @Input() author!: string;
  @Input() date!: Date;
  @Input() authorIconClass: string = 'bi bi-person';

  constructor(public helperService: HelperService) { }
}
